<template>
  <nuttrema-layout-form-standard :edit="edit" theme="west-top" :saveError="ServingSizeDetails.saveError">

    <template slot="center">
      <el-form
         label-position="top"
        :ref="formRef"
        :rules="rules"
        :model="formData">

        <section>
          <h4 class="section-title">
            {{ $t(`label.${_get(StuffToEatDetails, 'data.EntityType.code')}`) }}
          </h4>
          <div class="section-items">
            <stuff-to-eat-info-small-card
               slot="left"
              :details="StuffToEatDetails.data">
            </stuff-to-eat-info-small-card>
          </div>
        </section>

        <section>
          <h4 class="section-title">
            {{ $t('label.main_information') }}
          </h4>
          <div class="section-items">
            <el-form-item
               prop="title"
              :label="$t('label.title')">
              <el-col :span="24">
                <el-input
                  v-model="formData.title"
                  class="w-100">
                </el-input>
              </el-col>
            </el-form-item>

            <el-form-item
               prop="weight_gr"
              :label="$t('label.weight_gr')">
              <el-col :span="12">
                <el-input-number
                  v-model="formData.weight_gr"
                  class="w-100">
                </el-input-number>
              </el-col>
              <el-col :span="12" class="el-col--unit">
                <span>{{ $t('label.in_grams') }}</span>
              </el-col>
            </el-form-item>

            <el-form-item
               prop="description"
              :label="$t('label.description')">
              <el-col :span="24">
                <el-input
                  v-model="formData.description"
                  type="textarea"
                  class="w-100">
                </el-input>
              </el-col>
            </el-form-item>
          </div>
        </section>

      </el-form>

    </template>
    <!-- end ~ center -->

    <template slot="footer">
      <div class="footer-row" v-if="servingSizeID !== -1">
        <div class="row__column">
          <el-button
             type="primary"
             size="small"
            :loading="isSaving"
            @click="submitForm">
            {{ $t('label.save_changes') }}
          </el-button>
          <el-button type="text" size="small" @click="cancelChanges">{{ $t('label.cancel') }}</el-button>
        </div>

        <div class="row__column">
          <popover-question-alert
             popoverWidth="280"
             buttonSize="small"
             buttonType="danger"
             popoverPlacement="top-end"
             buttonTitle="label.delete"
            :popoverShouldShow="true"
            @confirmed="handleDelete">
          </popover-question-alert>
        </div>
      </div>

      <div class="footer-row" v-else>
        <el-button
           type="primary"
           size="small"
          :loading="isSaving"
          @click="submitForm">
          {{ $t('label.save_changes') }}
        </el-button>
        <el-button type="text" size="small" @click="cancelChanges">{{ $t('label.cancel') }}</el-button>
      </div>
    </template>
    <!-- end ~ footer -->

  </nuttrema-layout-form-standard>
</template>

<script>
import { isEmpty, get } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import NuttremaLayoutPopoverCred from 'components/ui/layout/nuttrema-layout-popover-cred';
import PopoverQuestionAlert from 'components/ui/alert/nuttrema-popover-question-alert';

import StuffToEatInfoSmallCard from 'components/ui/card/stuff-to-eat-info-small-card';

export default {
  name: 'form-create-serving-size',
  mixins: [
    FormStandardBehavior,
  ],
  props: {
    id: {
      required: true,
      default: null,
    },
    servingSizeID: {
      required: false,
      default: null,
    },
    type: {
      required: true,
      default: null,
    },
    edit: {
      required: false,
      default: true,
    },
    meta: {
      required: false,
    },
    StuffToEatDetails: {
      type: Object,
      required: true,
      default: null,
    },
    ServingSizeDetails: {
      type: Object,
      required: false,
      default: null,
    },
  },
  components: {
    PopoverQuestionAlert,
    StuffToEatInfoSmallCard,
    NuttremaLayoutPopoverCred,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        title: null,
        description: null,
        weight_gr: null,
      },
      rules: {
        title: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.title', true),
          },
        ],
        weight_gr: [
          {
            required: true,
            type: 'number',
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.weight', true),
          },
        ],
      },
    };
  },
  methods: {
    getFormData() {
      return this.removeEmpty(this.formData);
    },
    setFormData() {
      if (!isEmpty(this.ServingSizeDetails)) {
        this.formData.title = get(this.ServingSizeDetails, 'data.title', null);
        this.formData.description = get(this.ServingSizeDetails, 'data.description', null);
        this.formData.weight_gr = get(this.ServingSizeDetails, 'data.weight_gr', null);
      }
    },
  },
  created() {
    this.stateData = this.ServingSizeDetails;
    this.formRef = 'form-create-serving-size';
    this.setFormData();
  },
};
</script>

<style lang="scss" scoped>
  .el-col--unit {
    line-height: 2.5em;
    padding: 0 0.75em;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/serving-sizes/form-stuff-to-eat-cred-serving-size.vue